const newRenderOffer = (listParentDisplay) => {
  if (listParentDisplay.length) {
    let offerMarkup = "";
    const hasMoreItem = listParentDisplay.length > 3;
    JSON.parse(JSON.stringify(listParentDisplay))
      .splice(0, 3)
      .map((parentId, index) => {
        const parentData =
          window.tlAdvancedFreeGift.shopifyIdMapData.get(parentId);
        if (parentData) {
          offerMarkup += `
                <div class="salepify-fg-advanced-offer__item ${index == 2 && hasMoreItem ? "salepify-fg-advanced-offer__item--last" : ""}">
                    <img src="${parentData.image}" alt="${parentData.title}" width="71" height="71"/>
                    ${
                      index == 2 && hasMoreItem
                        ? `<svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.0625 2.5C5.0625 3.72538 4.06913 4.71875 2.84375 4.71875C1.61837 4.71875 0.625 3.72538 0.625 2.5C0.625 1.27462 1.61837 0.28125 2.84375 0.28125C4.06913 0.28125 5.0625 1.27462 5.0625 2.5Z" fill="white"/>
                            <path d="M11.7188 2.5C11.7188 3.72538 10.7254 4.71875 9.5 4.71875C8.27462 4.71875 7.28125 3.72538 7.28125 2.5C7.28125 1.27462 8.27462 0.28125 9.5 0.28125C10.7254 0.28125 11.7188 1.27462 11.7188 2.5Z" fill="white"/>
                            <path d="M16.1562 4.71875C17.3816 4.71875 18.375 3.72538 18.375 2.5C18.375 1.27462 17.3816 0.28125 16.1562 0.28125C14.9309 0.28125 13.9375 1.27462 13.9375 2.5C13.9375 3.72538 14.9309 4.71875 16.1562 4.71875Z" fill="white"/>
                        </svg>`
                        : ""
                    }
                </div>
            `;
        }
      });

    return `
            ${offerMarkup}
            <div class="salepify-fg-advanced-offer__plus-icon">
                <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7 0.5C7.55228 0.5 8 0.947715 8 1.5V6.5H13C13.5523 6.5 14 6.94772 14 7.5C14 8.05228 13.5523 8.5 13 8.5H8V13.5C8 14.0523 7.55228 14.5 7 14.5C6.44772 14.5 6 14.0523 6 13.5V8.5H1C0.447715 8.5 0 8.05228 0 7.5C0 6.94771 0.447715 6.5 1 6.5L6 6.5V1.5C6 0.947715 6.44772 0.5 7 0.5Z" fill="#111827"/>
                </svg>
            </div>

            <div class="salepify-fg-advanced-gift-offer-img">
                <div class="salepify-fg-advanced-icon-popup" style="position:relative;display: flex; background-image: none; bottom: 0; right: 0; border-radius: 8px;">
<div class="salepify-fg-advanced-icon-popup__icon" style="display: block;">
    <svg xmlns="http://www.w3.org/2000/svg" enablebackground="new 0 0 32 32" viewBox="0 0 32 32" id="gift">
        <defs>
            <linearGradient id="a">
                <stop offset="0" stopcolor="#000092"></stop>
                <stop offset="1" stopcolor="#ff00f3"></stop>
            </linearGradient>
            <linearGradient id="b" x1="4.75" x2="24.689" y1="16.25" y2="16.25" gradientUnits="userSpaceOnUse" xlink-href="#a">
            </linearGradient>
        </defs>
        <path fill="#ffffff" d="M 22.75 3.25 L 22.349609 4.8496094 L 20.75 5.25 L 22.349609 5.6503906 L 22.75 7.25 L 23.150391 5.6503906 L 24.75 5.25 L 23.150391 4.8496094 L 22.75 3.25 z M 25.75 3.25 L 25.550781 4.0507812 L 24.75 4.25 L 25.550781 4.4492188 L 25.75 5.25 L 25.949219 4.4492188 L 26.75 4.25 L 25.949219 4.0507812 L 25.75 3.25 z M 13.25 6.25 C 11.596 6.25 10.25 7.596 10.25 9.25 C 10.25 10.021 10.550297 10.718 11.029297 11.25 L 6.25 11.25 C 5.423 11.25 4.75 11.923 4.75 12.75 L 4.75 15.75 C 4.75 16.577 5.423 17.25 6.25 17.25 L 6.75 17.25 L 6.75 27.75 C 6.75 28.577 7.423 29.25 8.25 29.25 L 14.75 29.25 L 16.75 29.25 L 23.25 29.25 C 24.077 29.25 24.75 28.577 24.75 27.75 L 24.75 17.25 L 25.25 17.25 C 26.077 17.25 26.75 16.577 26.75 15.75 L 26.75 12.75 C 26.75 11.923 26.077 11.25 25.25 11.25 L 20.470703 11.25 C 20.950703 10.718 21.25 10.021 21.25 9.25 C 21.25 7.596 19.904 6.25 18.25 6.25 C 17.206 6.25 16.288 6.7866562 15.75 7.5976562 C 15.212 6.7866563 14.294 6.25 13.25 6.25 z M 13.25 7.25 C 14.353 7.25 15.25 8.147 15.25 9.25 L 15.25 11.25 L 14.75 11.25 L 13.25 11.25 C 12.147 11.25 11.25 10.353 11.25 9.25 C 11.25 8.147 12.147 7.25 13.25 7.25 z M 18.25 7.25 C 19.353 7.25 20.25 8.147 20.25 9.25 C 20.25 10.353 19.353 11.25 18.25 11.25 L 16.75 11.25 L 16.25 11.25 L 16.25 9.25 C 16.25 8.147 17.147 7.25 18.25 7.25 z M 24.75 7.25 L 24.550781 8.0507812 L 23.75 8.25 L 24.550781 8.4492188 L 24.75 9.25 L 24.949219 8.4492188 L 25.75 8.25 L 24.949219 8.0507812 L 24.75 7.25 z M 6.25 12.25 L 13.25 12.25 L 14.25 12.25 L 14.25 16.25 L 11.8125 16.25 L 7.25 16.25 L 6.25 16.25 C 5.974 16.25 5.75 16.025 5.75 15.75 L 5.75 12.75 C 5.75 12.475 5.974 12.25 6.25 12.25 z M 15.25 12.25 L 15.75 12.25 L 16.25 12.25 L 16.25 16.748047 L 16.25 16.75 L 16.25 16.751953 L 16.25 28.25 L 15.25 28.25 L 15.25 12.25 z M 17.25 12.25 L 18.25 12.25 L 25.25 12.25 C 25.526 12.25 25.75 12.475 25.75 12.75 L 25.75 15.75 C 25.75 16.025 25.526 16.25 25.25 16.25 L 24.25 16.25 L 19.21875 16.25 L 17.25 16.25 L 17.25 12.25 z M 7.75 17.25 L 11.8125 17.25 L 14.251953 17.25 L 14.251953 28.25 L 8.2519531 28.25 C 7.9749531 28.25 7.75 28.025 7.75 27.75 L 7.75 17.25 z M 17.25 17.25 L 19.21875 17.25 L 23.75 17.25 L 23.75 27.75 C 23.75 28.025 23.526 28.25 23.25 28.25 L 17.25 28.25 L 17.25 17.25 z ">
        </path>
    </svg>
</div>
</div>
            </div>
        `;
  } else {
    return "";
  }
};

const newShowIconPopUpMessage = (message, availableToClaim) => {
  window.tlAdvancedFreeGift.iconPopupBadgeTextElement.innerHTML =
    "Já pode ver a oferta no seu carrinho!";
  window.tlAdvancedFreeGift.iconPopupBadgeElement.style = "display: block";

  window.tlAdvancedFreeGift.iconPopupBadgeElement.querySelector("p").innerHTML =
    availableToClaim;
  window.tlAdvancedFreeGift.iconPopupElement.style.animation =
    "tlAdvancedFGShake 1s 2";
};

const expandAllOffer = () => {
  const allMainSections = document.querySelectorAll(
    "[id^=salepify-fg-advanced-main-section]",
  );

  allMainSections.forEach((section) => {
    if (
      section.classList.contains("salepify-fg-advanced-main-section--view-less")
    ) {
      section.classList.remove("salepify-fg-advanced-main-section--view-less");
      section.classList.add("salepify-fg-advanced-main-section--view-more");
    }
  });
};
let countToggle = 0
const newHandleToggle = (e) => {
  if (e && !e.target.classList.contains("salepify-fg-advanced-wrapper")) return;
  const modalWrapper = document.querySelector(".salepify-fg-advanced-wrapper");
  const modal = document.querySelector(".salepify-fg-advanced");
  if (modal.classList.contains("salepify-fg-advanced--hide")) {
    window.tlAdvancedFreeGift.increaseImpression();
    modal.classList.add("salepify-fg-advanced--show");
    modal.classList.remove("salepify-fg-advanced--hide");
    modalWrapper.style.visibility = "visible";
  } else {
    modal.classList.add("salepify-fg-advanced--hide");
    modal.classList.remove("salepify-fg-advanced--show");
    modalWrapper.style.visibility = "hidden";
  }

  expandAllOffer();
  if(countToggle === 0){
  document.querySelectorAll('.salepify-fg-advanced--detailed_list').forEach((el, index) => {
    const p = document.createElement('p');
    p.style="color: #000; font-size: 16px; font-weight: bold;"
    p.textContent = `OFERTA ${index + 1}`;
    el.prepend(p);
  });
  }
  countToggle++;

  // NOTE
  if (
    window.tlAdvancedFreeGift.displaySettings.layout ===
    window.tlAdvancedFreeGift.POPUP_LAYOUT.GIFTS_ONLY
  ) {
    window.tlAdvancedFreeGift.render();
  }
};

const intervalId = setInterval(() => {
  if (window.tlAdvancedFreeGift) {
    window.tlAdvancedFreeGift.renderOffer = newRenderOffer;
    window.tlAdvancedFreeGift.showIconPopUpMessage = newShowIconPopUpMessage;
    window.tlAdvancedFreeGift.handleToggle = newHandleToggle;

    const addButton = document.querySelector(
      ".salepify-fg-advanced-temp-cart__add-to-cart-btn",
    );
    addButton.innerText = "Adicionar ao carrinho";
    const deleteButton = document.querySelector(
      ".salepify-fg-advanced-temp-cart__remove-all-btn",
    );
    deleteButton.innerText = "Remover todos";

    clearInterval(intervalId);
  }
}, 10);

setTimeout(() => {
  clearInterval(intervalId);
}, 5000);
